import { Cookie } from '../hook/use-bxp-web-stargate-client.types';

import { serialize } from 'cookie';

export function serializeCookie({ name, value }: Cookie): string {
	return serialize(name, value);
}

export function mapCookieToHeaders(cookie?: Cookie): HeadersInit {
	if (cookie) {
		return { cookie: serializeCookie(cookie) };
	} else {
		return {};
	}
}
